/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_On_BrandsInputs */

const en_waiting_on_brands = /** @type {(inputs: Waiting_On_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on the brands`)
};

/**
* | output |
* | --- |
* | "Waiting on the brands" |
*
* @param {Waiting_On_BrandsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waiting_on_brands = /** @type {((inputs?: Waiting_On_BrandsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_On_BrandsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_waiting_on_brands(inputs)
});